import React from 'react';
import { useGetLegalClientLogsByLegalClient } from '../../hooks/reactQuerys/LegalClientQueries';
import { CustomCircularProgress } from '../../generic/CustomCircularProgress';
import { Box, Button, Typography } from '@mui/material';
import { ActivityLog } from '../../generic/ActivityLog';

/** Bereiche des Mandanten-Protokolls — spiegeln die Reiter dieses Dialogs. */
const CLIENT_LOG_AREAS = [
  { label: 'Stammdaten', entityTypes: ['LegalClient'] },
  {
    label: 'Portal-Zugang',
    entityTypes: ['LegalClientUser', 'LegalClientInvite'],
  },
  {
    label: 'Adressen',
    entityTypes: ['Address', 'LegalClientAddress'],
  },
  {
    label: 'Kontaktdaten',
    entityTypes: ['ContactInformation', 'LegalClientContactInformation'],
  },
  {
    label: 'Bankverbindung',
    entityTypes: ['Accounting', 'LegalClientAccounting'],
  },
  {
    label: 'Dokumente',
    entityTypes: [
      'Document',
      'LegalClientDocument',
      'LegalClientDocumentVersion',
    ],
  },
  {
    label: 'Vorgänge',
    entityTypes: ['LegalTransaction', 'LegalTransactionLegalClient'],
  },
  { label: 'Aufgaben', entityTypes: ['Task', 'TaskComment'] },
  {
    label: 'Gruppen',
    entityTypes: ['LegalClientGroup', 'LegalClient_has_LegalClientGroup'],
  },
];

interface IProps {
  idLegalClient: number;
}

export const LogTab: React.FC<IProps> = ({ idLegalClient }) => {
  const { legalClientLogs, isLoadingLegalClientLogs, refetchLegalClientLogs } =
    useGetLegalClientLogsByLegalClient(idLegalClient);

  if (isLoadingLegalClientLogs) {
    return <CustomCircularProgress />;
  }

  if (!legalClientLogs) {
    return (
      <Box
        sx={{
          minHeight: '50vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
        }}
      >
        <Typography variant='h6'>
          Fehler beim Laden der Daten. Bitte versuchen Sie es erneut.
        </Typography>
        <Button variant='contained' onClick={() => refetchLegalClientLogs()}>
          Erneut versuchen
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Typography variant='h5'>Log</Typography>

      <Box sx={{ mt: 2 }}>
        <ActivityLog
          entityType='LegalClient'
          entityId={idLegalClient}
          areas={CLIENT_LOG_AREAS}
        />
      </Box>
    </>
  );
};
